<div class="perfil-container">
 
  <div class="meu-perfil-container">
     <div class="modal-accent-bar"></div>
    <div class="header">
      <div class="title">
        <img
          src="{{ BASE_IMG_URL }}assets/icons/profile.svg"
          alt="Logo"
        />
        <div>
          <h2>Meu Perfil</h2>
          <p>
            Gerencie suas informações e mantenha sua conta segura.<br />
            Aqui você pode atualizar seus dados de contato e alterar sua senha
            de acesso à plataforma.
          </p>
        </div>
      </div>

      <div class="perfil-info">
        <div class="perfil-nome">{{ nomeUsuario }}</div>
        <div class="perfil-email">{{ emailUsuario }}</div>
      </div>
    </div>
  </div>

  <div class="perfil-cards">
    <a
      class="perfil-card"
      routerLink="/usuario/dados-cadastrais"
      style="cursor: pointer; text-decoration: none; color: inherit;"
    >
      <div class="perfil-card-icon">
        <span class="material-icons">person</span>
      </div>
      <div class="perfil-card-content">
        <div class="perfil-card-title">Informações do seu perfil</div>
        <div class="perfil-card-desc">
          Atualize seus dados pessoais e de contato, como nome e e-mail, para
          manter suas informações sempre corretas no sistema.
        </div>
      </div>
    </a>
    <a
      class="perfil-card"
      routerLink="/usuario/senha"
      style="cursor: pointer; text-decoration: none; color: inherit;"
    >
      <div class="perfil-card-icon">
        <span class="material-icons">shield</span>
      </div>
      <div class="perfil-card-content">
        <div class="perfil-card-title">Segurança</div>
        <div class="perfil-card-desc">
          Altere sua senha de acesso para manter sua conta protegida e garantir
          mais segurança no uso da plataforma.
        </div>
      </div>
      <div class="perfil-card-alert">
        <span class="material-icons alert">error_outline</span>
      </div>
    </a>
  </div>
</div>
